<template>
  <div>
    <div
      class="row col-12 q-gutter-sm q-mt-lg q-ml-lg text-brand-5 text-weight-bold container-input"
    >
      <div
        v-if="botaoTipo == 'criar'"
        class="row col-12 q-gutter-x-sm container-input"
      >
        <div class="col-md-2 col-sm-3 col-xs-3">
          <div class="q-ml-sm titulo-input">Cód CA</div>
          <q-input class="input" v-model="dados.codigo" dense outlined />
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4">
          <div class="q-ml-sm titulo-input">Validade</div>
          <q-input
            v-model="dados.dataExpiracao"
            dense
            outlined
            default
            class="input"
            mask="##/##/####"
          >
            <template v-slot:prepend>
              <q-icon name="event" class="cursor-pointer icon">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dados.dataExpiracao"
                    mask="DD/MM/YYYY"
                    :locale="myLocale"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div>
          <p></p>
          <q-btn
            dense
            outlined
            label="Adicionar CA"
            class="q-mt-sm btn"
            no-caps
            color="primary"
            icon="add_circle_outline"
            flat
            @click="adicionarCA()"
          />
        </div>
      </div>
      <div
        v-if="botaoTipo == 'atualizar'"
        class="row col-12 q-gutter-x-sm container-input"
      >
        <div class="col-md-2 col-sm-3 col-xs-3">
          <div class="q-ml-sm titulo-input">Cód CA</div>
          <q-select
            dense
            v-model="caAtualizar"
            use-input
            hide-selected
            fill-input
            outlined
            class="input"
            input-debounce="0"
            :options="options"
            @filter="filterFn"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey"
                  >Sem resultados</q-item-section
                >
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4">
          <div class="q-ml-sm titulo-input">Validade</div>
          <q-input
            v-model="dados.dataAtualizar"
            dense
            outlined
            default
            class="input"
            mask="##/##/####"
          >
            <template v-slot:prepend>
              <q-icon name="event" class="cursor-pointer icon">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dados.dataAtualizar"
                    mask="DD/MM/YYYY"
                    :locale="myLocale"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div>
          <p></p>
          <q-btn
            dense
            outlined
            label="Atualizar CA"
            class="q-mt-sm btn"
            no-caps
            color="primary"
            icon="add_circle_outline"
            flat
            @click="atualizarValidadeCa()"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl container-table">
      <div
        class="row col-12 q-ml-md q-mt-md q-mb-lg text-brand-5 titulo-table text-subtitle1 text-weight-bold"
      >
        Lista de CAs Criados
      </div>
      <div
        class="row col-12 items-center justify-between text-brand-5 text-weight-bold q-mb-lg q-ml-md container-input-search"
      >
        <div class="row col-md-12 col-xs justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="busca"
            type="text"
            class="col-md-3 col-xs"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaCas"
        flat
        dense
        table-header-class="bg-accent text-weight-bold"
        hide-pagination
        v-model:pagination="pagination"
        :loading="loading"
        class="tabela-tamanho-fixo"
        :filter="busca"
        @request="paginarTabela"
        :grid="$q.screen.lt.sm"
        color="primary"
        hide-bottom
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div class="row col-12 items-center justify-between">
                <span class="col-9 q-ml-sm"
                  ><strong>Codigo: </strong>{{ props.row.code }}</span
                >
              </div>
              <div class="row col-12 items-center justify-end">
                <span class="q-ml-sm row items-center"
                  ><strong>Status: </strong>
                  <div
                    v-if="props.row.status == 'Válido'"
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div style="width: fit-content" class="text-brand-5">
                      {{ props.row.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div style="width: fit-content">
                      {{ props.row.status }}
                    </div>
                  </div></span
                >
                <div></div>
              </div>
              <div class="row col-12 items-center justify-between">
                <span class="col-9 q-ml-sm"
                  ><strong>Vencimento: </strong
                  >{{
                    props.row.expires_in
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}</span
                >
                <div></div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigoCa="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-vencimento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.expires_in?.split(" ")[0].split("-").reverse().join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td>
            <div
              v-if="props.row.status == 'Válido'"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ props.row.status }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ props.row.status }}
              </div>
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="loading"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "codigoCa",
    label: "Código CA",
    align: "left",
    field: "code",
  },
  {
    name: "vencimento",
    label: "Vencimento",
    align: "left",
    field: "expires_in",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
];
export default {
  props: ["botaoTipo"],
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const time = ref();
    const listaCas = ref([]);
    const options = ref([]);
    const timer = ref(null);
    const timer2 = ref(null);
    let caAtualizar = ref(null);
    const busca = ref("");
    const dados = ref({
      dataAtualizar: "",
      codigo: "",
      dataExpiracao: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      // rowsNumber: 6,
    });
    const disable = ref(false);
    const loading = ref(false);

    const listarSelect = async (val) => {
      options.value = [];
      try {
        let response = await store.dispatch("produtosNovo/listarCas", {
          code: val,
          per_page: 15,
        });
        response.data.results.data.forEach((ca) => {
          options.value.push({
            value: ca.id,
            label: ca.code,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const listarCas = async (page = 1) => {
      loading.value = true;
      let ca = "";
      if (caAtualizar.value != null) {
        ca = caAtualizar.value.label;
      }
      try {
        let response = await store.dispatch("produtosNovo/listarCas", {
          code: ca,
          per_page: 1000,
          page: page,
          search: busca.value,
        });
        listaCas.value = response.data.results.data;
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const atualizarValidadeCa = async () => {
      if (dados.value.dataAtualizar == "" || caAtualizar.value.label == "") {
        quasar.notify({
          message: "Preencha todos os campos para atualizar um CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("produtosNovo/atualizarCa", {
          code: caAtualizar.value.label,
          id: caAtualizar.value.value,
          expires_in: dados.value.dataAtualizar,
        });
        caAtualizar.value = null;
        dados.value.dataAtualizar = "";
        listarCas();
        quasar.notify({
          message: "Data de validade atualizada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar data de validade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = async () => {
      listarCas(pagination.value.page, pagination.value.rowsPerPage);
    };

    const adicionarCA = async () => {
      if (dados.value.dataExpiracao == "" || dados.value.codigo == "") {
        quasar.notify({
          message: "Preencha todos os campos para adicionar um CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let data;

      data = dados.value.dataExpiracao;

      if (data) {
        let dia = dados.value.dataExpiracao.split("/")[0];
        let mes = dados.value.dataExpiracao.split("/")[1];
        let ano = dados.value.dataExpiracao.split("/")[2];

        data = ano + "-" + mes + "-" + dia;
      }
      try {
        await store.dispatch("produtosNovo/adicionarCa", {
          code: dados.value.codigo,
          expires_in: `${data}T00:00:00.000Z`,
          format: "Y-m-d\\TH:i:s.u\\Z",
        });
        quasar.notify({
          message: "CA adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        dados.value.dataExpiracao = "";
        dados.value.codigo = "";
      } catch (error) {
        if (
          error.response?.data?.errors?.code[0] ===
          "code deve conter apenas números ou os caracteres /|-_"
        ) {
          quasar.notify({
            message:
              "O código deve conter apenas números ou os caracteres /|-_",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Erro ao adicionar CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => caAtualizar.value,
      () => {
        listarCas();
      }
    );

    onMounted(listarCas);

    return {
      columns,
      listaCas,
      listarSelect,
      timer,
      timer2,
      caAtualizar,
      filterFn(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarSelect(val);
        }, 2000);

        setTimeout(() => {
          update(() => {
            const needle = val.toLowerCase();
            options.value = options.value.filter((v) => {
              v.label.toLowerCase().indexOf(needle) > -1;
              return v;
            });
          });
        }, 2500);
      },
      dados,
      options,
      time,
      atualizarValidadeCa,
      busca,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      paginarTabela,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(listaCas.value.length / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      adicionarCA,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .container-input {
    margin: 13px 0px 0px 0px;
  }
  .btn {
    font-size: 12px;
  }
  .container-table {
    margin: 40px 0px 0px 0px;
  }
  .titulo-table {
    display: none;
  }
  .input {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px 0px 0px;
  }
  .container-input-search {
    margin: 40px 0px;
  }
}
</style>
